// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.package_packagesContainer__cBZdm {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
}
.package_packagesContainer__cBZdm .package_packageCard__xTd\\+S {
  border: 1px solid #E0E0E0;
  border-radius: 12px;
  padding: 12px;
  background-color: #FFFFFF;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.package_packagesContainer__cBZdm .package_packageName__edigo {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
}
.package_packagesContainer__cBZdm .package_packageName__edigo h6 {
  font: var(--body-font-three);
  font-weight: 600;
  color: #313131;
}
.package_packagesContainer__cBZdm .package_packageDescription__I4MOg {
  color: #8692A4;
  margin-bottom: 4px;
  font: var(--body-font-three);
}
.package_packagesContainer__cBZdm .package_packagePrice__66T-y {
  font: var(--body-font-two);
  font-weight: 600;
  color: #313131;
}
.package_packagesContainer__cBZdm .package_packageAddons__5n6qs {
  border-top: 1px solid #DFE4EB;
  margin-top: 12px;
}
.package_packagesContainer__cBZdm .package_packageAddons__5n6qs .package_packageAddonsTitle__q2lp- {
  color: #8692A4;
  padding: 7px 0;
  font: var(--body-font-four);
}
.package_packagesContainer__cBZdm .package_packageAddons__5n6qs .package_packageAddonsList__ZK3nf {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.package_packagesContainer__cBZdm .package_packageAddons__5n6qs .package_packageAddonsList__ZK3nf .package_packageAddonsItem__4vDEk {
  border: 1px solid #DFE4EB;
  border-radius: 12px;
  padding: 8px;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.package_packagesContainer__cBZdm .package_packageAddons__5n6qs .package_packageAddonsList__ZK3nf .package_packageAddonsItemNamemain__KgsD9 .package_packageAddonsItemName__iq-ls {
  color: #313131;
  font: var(--body-font-three);
}
.package_packagesContainer__cBZdm .package_packageAddons__5n6qs .package_packageAddonsList__ZK3nf .package_packageAddonsItemNamemain__KgsD9 .package_packageAddonsItemPrice__Sei3P {
  color: #313131;
  font: var(--body-font-three);
  font-weight: 600;
}
.package_packagesContainer__cBZdm .package_packageAddons__5n6qs .package_packageAddonsList__ZK3nf .package_packageAddonsItemRequired__Y1IQ1 {
  background-color: #F44336;
  color: #FFFFFF;
  padding: 1px 7px;
  border-radius: 500px;
  font: var(--body-font-four);
  white-space: nowrap;
  flex-shrink: 0;
}

.package_packageAddonsItem__4vDEk {
  border: 1px solid #DFE4EB;
  border-radius: 12px;
  padding: 8px;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.package_packageAddonsItem__4vDEk .package_packageAddonsItemNameMain__pcKMT {
  display: flex;
  align-items: center;
  gap: 12px;
}
@media (max-width: 768px) {
  .package_packageAddonsItem__4vDEk .package_packageAddonsItemNameMain__pcKMT {
    flex-direction: column;
    align-items: start;
    gap: 4px;
  }
}
.package_packageAddonsItem__4vDEk .package_packageAddonsItemName__iq-ls {
  font: var(--body-font-three);
  font-weight: 600;
  color: #313131;
}
.package_packageAddonsItem__4vDEk .package_packageAddonsItemTags__Q2Gij {
  display: flex;
  gap: 8px;
}
.package_packageAddonsItem__4vDEk .package_packageAddonsItemTags__Q2Gij .package_packageAddonsItemRequired__Y1IQ1 {
  background-color: #F44336;
  color: #FFFFFF;
  padding: 1px 7px;
  border-radius: 500px;
  font: var(--body-font-four);
  white-space: nowrap;
  flex-shrink: 0;
}
.package_packageAddonsItem__4vDEk .package_packageAddonsItemTags__Q2Gij .package_packageAddonsItemTagsDefault__M1qw2 {
  background-color: #F5F5F5;
  color: #666666;
  padding: 1px 7px;
  border-radius: 500px;
  font: var(--body-font-four);
  white-space: nowrap;
  flex-shrink: 0;
}
.package_packageAddonsItem__4vDEk .package_packageAddonsItemDescription__ELBMX {
  color: #8692A4;
  margin-top: 4px;
  font: var(--body-font-three);
}
.package_packageAddonsItem__4vDEk .package_packageAddonsItemPrice__Sei3P {
  margin-top: 4px;
  font: var(--body-font-two);
  font-weight: 600;
  color: #313131;
}

.package_noAddonsTitle__xHXMM {
  color: var(--primary-Text);
  font: var(--h6);
  font-weight: 600;
  margin-bottom: 4px;
}

.package_noAddonsDescription__dvnIi {
  color: var(--brand);
  font: var(--body-font-two);
  cursor: pointer;
}

.package_packageAddonsLibraryTitle__GhofD {
  color: var(--primary-Text);
  font: var(--body-font-three);
  margin-bottom: 8px;
}

@media (max-width: 768px) {
  .package_packageAddonsHeader__Xh6aS {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/profileCards/vendor/package.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AACJ;AACI;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACR;AAEI;EACI,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;AAAR;AAEQ;EACI,4BAAA;EACA,gBAAA;EACA,cAAA;AAAZ;AAII;EACI,cAAA;EACA,kBAAA;EACA,4BAAA;AAFR;AAKI;EACI,0BAAA;EACA,gBAAA;EACA,cAAA;AAHR;AAMI;EACI,6BAAA;EACA,gBAAA;AAJR;AAOQ;EACI,cAAA;EACA,cAAA;EACA,2BAAA;AALZ;AASQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAPZ;AASY;EACI,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAPhB;AAWgB;EACI,cAAA;EACA,4BAAA;AATpB;AAYgB;EACI,cAAA;EACA,4BAAA;EACA,gBAAA;AAVpB;AAcY;EACI,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;AAZhB;;AAoBA;EACI,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAjBJ;AAmBI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAjBR;AAmBQ;EALJ;IAMQ,sBAAA;IACA,kBAAA;IACA,QAAA;EAhBV;AACF;AAmBI;EACI,4BAAA;EACA,gBAAA;EACA,cAAA;AAjBR;AAoBI;EACI,aAAA;EACA,QAAA;AAlBR;AAoBQ;EACI,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;AAlBZ;AAqBQ;EACI,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;AAnBZ;AAuBI;EACI,cAAA;EACA,eAAA;EACA,4BAAA;AArBR;AAwBI;EACI,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;AAtBR;;AA2BA;EACI,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAxBJ;;AA2BA;EACI,mBAAA;EACA,0BAAA;EACA,eAAA;AAxBJ;;AA2BA;EACI,0BAAA;EACA,4BAAA;EACA,kBAAA;AAxBJ;;AA2BA;EACI;IACI,eAAA;EAxBN;AACF","sourcesContent":[".packagesContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n    margin-top: 16px;\r\n\r\n    .packageCard {\r\n        border: 1px solid #E0E0E0;\r\n        border-radius: 12px;\r\n        padding: 12px;\r\n        background-color: #FFFFFF;\r\n        position: relative;\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 2px;\r\n    }\r\n\r\n    .packageName {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: flex-start;\r\n        margin-bottom: 4px;\r\n\r\n        h6 {\r\n            font: var(--body-font-three);\r\n            font-weight: 600;\r\n            color: #313131;\r\n        }\r\n    }\r\n\r\n    .packageDescription {\r\n        color: #8692A4;\r\n        margin-bottom: 4px;\r\n        font: var(--body-font-three);\r\n    }\r\n\r\n    .packagePrice {\r\n        font: var(--body-font-two);\r\n        font-weight: 600;\r\n        color: #313131;\r\n    }\r\n\r\n    .packageAddons {\r\n        border-top: 1px solid #DFE4EB;\r\n        margin-top: 12px;\r\n\r\n\r\n        .packageAddonsTitle {\r\n            color: #8692A4;\r\n            padding: 7px 0;\r\n            font: var(--body-font-four);\r\n\r\n        }\r\n\r\n        .packageAddonsList {\r\n            display: flex;\r\n            flex-direction: column;\r\n            gap: 8px;\r\n\r\n            .packageAddonsItem {\r\n                border: 1px solid #DFE4EB;\r\n                border-radius: 12px;\r\n                padding: 8px;\r\n                background-color: #FFFFFF;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: space-between;\r\n                gap: 12px;\r\n            }\r\n\r\n            .packageAddonsItemNamemain {\r\n                .packageAddonsItemName {\r\n                    color: #313131;\r\n                    font: var(--body-font-three);\r\n                }\r\n\r\n                .packageAddonsItemPrice {\r\n                    color: #313131;\r\n                    font: var(--body-font-three);\r\n                    font-weight: 600;\r\n                }\r\n            }\r\n\r\n            .packageAddonsItemRequired {\r\n                background-color: #F44336;\r\n                color: #FFFFFF;\r\n                padding: 1px 7px;\r\n                border-radius: 500px;\r\n                font: var(--body-font-four);\r\n                white-space: nowrap;\r\n                flex-shrink: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Modal styles\r\n.packageAddonsItem {\r\n    border: 1px solid #DFE4EB;\r\n    border-radius: 12px;\r\n    padding: 8px;\r\n    background-color: #FFFFFF;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 12px;\r\n\r\n    .packageAddonsItemNameMain {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 12px;\r\n\r\n        @media (max-width: 768px) {\r\n            flex-direction: column;\r\n            align-items: start;\r\n            gap: 4px;\r\n        }\r\n    }\r\n\r\n    .packageAddonsItemName {\r\n        font: var(--body-font-three);\r\n        font-weight: 600;\r\n        color: #313131;\r\n    }\r\n\r\n    .packageAddonsItemTags {\r\n        display: flex;\r\n        gap: 8px;\r\n\r\n        .packageAddonsItemRequired {\r\n            background-color: #F44336;\r\n            color: #FFFFFF;\r\n            padding: 1px 7px;\r\n            border-radius: 500px;\r\n            font: var(--body-font-four);\r\n            white-space: nowrap;\r\n            flex-shrink: 0;\r\n        }\r\n\r\n        .packageAddonsItemTagsDefault {\r\n            background-color: #F5F5F5;\r\n            color: #666666;\r\n            padding: 1px 7px;\r\n            border-radius: 500px;\r\n            font: var(--body-font-four);\r\n            white-space: nowrap;\r\n            flex-shrink: 0;\r\n        }\r\n    }\r\n\r\n    .packageAddonsItemDescription {\r\n        color: #8692A4;\r\n        margin-top: 4px;\r\n        font: var(--body-font-three);\r\n    }\r\n\r\n    .packageAddonsItemPrice {\r\n        margin-top: 4px;\r\n        font: var(--body-font-two);\r\n        font-weight: 600;\r\n        color: #313131;\r\n    }\r\n\r\n}\r\n\r\n.noAddonsTitle {\r\n    color: var(--primary-Text);\r\n    font: var(--h6);\r\n    font-weight: 600;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.noAddonsDescription {\r\n    color: var(--brand);\r\n    font: var(--body-font-two);\r\n    cursor: pointer;\r\n}\r\n\r\n.packageAddonsLibraryTitle {\r\n    color: var(--primary-Text);\r\n    font: var(--body-font-three);\r\n    margin-bottom: 8px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .packageAddonsHeader {\r\n        flex-wrap: wrap;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"packagesContainer": `package_packagesContainer__cBZdm`,
	"packageCard": `package_packageCard__xTd+S`,
	"packageName": `package_packageName__edigo`,
	"packageDescription": `package_packageDescription__I4MOg`,
	"packagePrice": `package_packagePrice__66T-y`,
	"packageAddons": `package_packageAddons__5n6qs`,
	"packageAddonsTitle": `package_packageAddonsTitle__q2lp-`,
	"packageAddonsList": `package_packageAddonsList__ZK3nf`,
	"packageAddonsItem": `package_packageAddonsItem__4vDEk`,
	"packageAddonsItemNamemain": `package_packageAddonsItemNamemain__KgsD9`,
	"packageAddonsItemName": `package_packageAddonsItemName__iq-ls`,
	"packageAddonsItemPrice": `package_packageAddonsItemPrice__Sei3P`,
	"packageAddonsItemRequired": `package_packageAddonsItemRequired__Y1IQ1`,
	"packageAddonsItemNameMain": `package_packageAddonsItemNameMain__pcKMT`,
	"packageAddonsItemTags": `package_packageAddonsItemTags__Q2Gij`,
	"packageAddonsItemTagsDefault": `package_packageAddonsItemTagsDefault__M1qw2`,
	"packageAddonsItemDescription": `package_packageAddonsItemDescription__ELBMX`,
	"noAddonsTitle": `package_noAddonsTitle__xHXMM`,
	"noAddonsDescription": `package_noAddonsDescription__dvnIi`,
	"packageAddonsLibraryTitle": `package_packageAddonsLibraryTitle__GhofD`,
	"packageAddonsHeader": `package_packageAddonsHeader__Xh6aS`
};
export default ___CSS_LOADER_EXPORT___;
